import { render, staticRenderFns } from "./zhusu.vue?vue&type=template&id=3a4643d5&"
import script from "./zhusu.vue?vue&type=script&lang=ts&"
export * from "./zhusu.vue?vue&type=script&lang=ts&"
import style0 from "./zhusu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports